"use strict";
exports.__esModule = true;
exports.EARLY_PAY_SUCCESS_MODAL = exports.CANCEL_TRANSACTION_MODAL = exports.EARLY_PAY = void 0;
exports.EARLY_PAY = {
    MAIN_TEXT: 'You submitted rent before making your 1st payment',
    SUB_TEXT: 'Make your 1st payment of {{paymentAmount}} by {{date}} so that we can approve your rent transaction. Your rent won’t be paid until this step is complete.',
    CTA: 'Make 1st payment'
};
exports.CANCEL_TRANSACTION_MODAL = {
    TITLE: 'Want to cancel your rent transaction?',
    SUBTITLE: "We can cancel your transaction of {{transactionAmount}} if it was submitted by mistake.\n\nWhen you confirm you'd like to cancelAnimationFrame, we will withdraw the transaction request from your property's portal. This may result in unwanted consequences, such as your porrtal charging a fee or blocking bank accounts.\n\n Make sure to only use the Flex bank account when you want to pay rent with Flex.",
    DISMISS_CTA: 'Never Mind',
    CONFIRM_CTA: 'Confirm cancellation'
};
exports.EARLY_PAY_SUCCESS_MODAL = {
    TITLE: 'Thanks for your payment!',
    SUBTITLE: 'We’ve processed your payment of {{paymentAmount}} and will approve your rent transaction.\n\nYour remaining balance is scheduled to be collected on {{additionalPaymentDate}}.',
    CTA: 'Done'
};
